export default __webpack_public_path__ + "static/AeonikBlack-1b4ddd48decda75e360bcc1bfb3a2641.otf";